import { render, staticRenderFns } from "./FederationPublishDialog.vue?vue&type=template&id=0444ff24&scoped=true"
import script from "./FederationPublishDialog.vue?vue&type=script&lang=js"
export * from "./FederationPublishDialog.vue?vue&type=script&lang=js"
import style0 from "./FederationPublishDialog.vue?vue&type=style&index=0&id=0444ff24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444ff24",
  null
  
)

export default component.exports